import { Box, BoxProps } from '@modusign/design-system';

interface QuestionCircleIconProps extends BoxProps<'svg'> {}

/**
 * 다른 아이콘은 @modusign/design-system/src/Icon 하위에 배치했지만 이 아이콘은
 * 공통으로 사용될 가능성이 낮다고 판단하여 HelpButton 컴포넌트 하위에
 * 작성합니다. 추후 공통으로 사용된다면 상위로 위치를 조정할 수 있습니다.
 */
const QuestionCircleIcon = (props: QuestionCircleIconProps) => {
  return (
    <Box
      as="svg"
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="16" cy="16" r="10.25" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M14.7879 19.3182H16.322V19.2415C16.3476 17.6562 16.7567 16.9659 17.8817 16.2628C19.0067 15.5788 19.6714 14.5945 19.6714 13.1818C19.6714 11.1875 18.214 9.73011 15.964 9.73011C13.893 9.73011 12.2503 11.0085 12.1544 13.1818H13.7652C13.8611 11.6733 14.9157 11.0597 15.964 11.0597C17.1657 11.0597 18.1373 11.8523 18.1373 13.1051C18.1373 14.1214 17.5557 14.8501 16.8078 15.304C15.555 16.0646 14.8071 16.8061 14.7879 19.2415V19.3182ZM15.6061 23.1023C16.2389 23.1023 16.7567 22.5845 16.7567 21.9517C16.7567 21.3189 16.2389 20.8011 15.6061 20.8011C14.9733 20.8011 14.4555 21.3189 14.4555 21.9517C14.4555 22.5845 14.9733 23.1023 15.6061 23.1023Z"
        fill="currentColor"
      />
    </Box>
  );
};

export default QuestionCircleIcon;
